export const REF_NAME = 'DELIVERYTERM';
export const REF_PATH = 'deliveryterm';
export const NAME = 'Delivery term';
